import {
  Footer,
  Header 
} from "./components";
import { MainPage } from "./pages";



function App() {
  return (
    <div className="wrapper">
      <Header/>
      <div className="page">
        <MainPage/>
      </div>
      <Footer/>
    </div>
  );
}

export default App;
